var _rect, _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMaterialIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 38,
    rx: 19,
    fill: "#00D46D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.4998 27.9583H16.4998C11.9748 27.9583 10.0415 26.025 10.0415 21.5V16.5C10.0415 11.975 11.9748 10.0416 16.4998 10.0416H20.6665C21.0082 10.0416 21.2915 10.325 21.2915 10.6666C21.2915 11.0083 21.0082 11.2916 20.6665 11.2916H16.4998C12.6582 11.2916 11.2915 12.6583 11.2915 16.5V21.5C11.2915 25.3416 12.6582 26.7083 16.4998 26.7083H21.4998C25.3415 26.7083 26.7082 25.3416 26.7082 21.5V17.3333C26.7082 16.9916 26.9915 16.7083 27.3332 16.7083C27.6748 16.7083 27.9582 16.9916 27.9582 17.3333V21.5C27.9582 26.025 26.0248 27.9583 21.4998 27.9583Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3332 17.9583H23.9998C21.1498 17.9583 20.0415 16.8499 20.0415 13.9999V10.6666C20.0415 10.4166 20.1915 10.1833 20.4248 10.0916C20.6582 9.99162 20.9248 10.0499 21.1082 10.2249L27.7748 16.8916C27.9498 17.0666 28.0082 17.3416 27.9082 17.5749C27.8082 17.8083 27.5832 17.9583 27.3332 17.9583ZM21.2915 12.1749V13.9999C21.2915 16.1499 21.8498 16.7083 23.9998 16.7083H25.8248L21.2915 12.1749Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8335 20.4584H14.8335C14.4918 20.4584 14.2085 20.175 14.2085 19.8334C14.2085 19.4917 14.4918 19.2084 14.8335 19.2084H19.8335C20.1752 19.2084 20.4585 19.4917 20.4585 19.8334C20.4585 20.175 20.1752 20.4584 19.8335 20.4584Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1668 23.7916H14.8335C14.4918 23.7916 14.2085 23.5083 14.2085 23.1666C14.2085 22.825 14.4918 22.5416 14.8335 22.5416H18.1668C18.5085 22.5416 18.7918 22.825 18.7918 23.1666C18.7918 23.5083 18.5085 23.7916 18.1668 23.7916Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaterialIcon);
export default __webpack_public_path__ + "static/media/materialIcon.7e3de2b5eacfed8232d017ac9b7da192.svg";
export { ForwardRef as ReactComponent };